<template>
  <div class="cargo-order-detail">
    <!--    <div class="cargo-order-overflow" v-if="orderForm.OPER_STATUS === 4">
          <span>{{ $t('cancellationText') }}</span>
        </div>-->
    <dol-row class="order-detail-page">
      <dol-col class="order-detail-left" style="margin-right: 24px">
        <!--   订单详情   -->
        <a-card class="order-detail-content">
          <span class="order-detail-content-title">{{$dt(orderForm, 'ORDER_STATUS_NAME')}}</span>
          <a-divider />
          <div class="order-detail-content-main">
            <div style="flex: 1">
              <a-row class="order-detail-content-code">
                <a-col :span="12">{{ $t('orderNumber') }}：{{ orderForm.VOUCHER_CODE }}</a-col>
                <a-col :span="12">{{$t('orderDate')}}: {{ $moment(orderForm.XB_CREATE_DATE).format('YYYY-MM-DD') }}</a-col>
              </a-row>
              <a-row class="order-detail-content-day">
                <a-col :span="12">
                  {{ $t('useBoxDay') }}：<span style="color: #1F6CBA">{{ orderForm.USE_DAYS || 0 }}</span>{{ $t('day') }}
                  <span>{{ $t('fromTheDateOfPacking') }}</span>
                </a-col>
                <a-col :span="12">
                  <a-popover placement="bottom">
                    <template slot="content">
                      <span>{{ $t('lagBoxFeesHint') }}</span>
                      <table class="table-rule-page">
                        <thead>
                        <tr class="table-rule-header">
                          <th>{{ $t('beyondTheTime') }}</th>
                          <th>{{ $t('detentionFeeType') }}</th>
                          <th>{{ $t('lagBoxFees') }}</th>
                        </tr>
                        </thead>
                        <tr class="table-body" v-for="(item,index) in orderRuleList" :key="index">
                          <td v-if="item.PRICE_WAY === 0">{{item.DELAY_DAY}}-{{item.DELAY_DAY2}}</td>
                          <td v-if="item.PRICE_WAY === 1"><span style="font-weight: 600;margin-right: 2px">≧</span>{{item.DELAY_DAY}}{{$t('day')}}</td>
                          <td>{{item.PRICE_WAY === 0 ? $t('daily') : $t('loss')}}</td>
                          <td>
                            <span>{{ item.SYMBOL }}{{item.PRICE}}</span>
                          </td>
                        </tr>
                      </table>
                    </template>
                    <span style="color: #333333">{{$t('containerDetentionCharge')}}</span>: <a>{{ $t('viewRule') }}</a>
                  </a-popover>
                </a-col>
              </a-row>
            </div>
<!--            <a-button  class="order-detail-content-pay_button" @click="downPayCard">-->
<!--              {{ $t('payOrder') }}</a-button>-->
          </div>
          <div class="user-box-hint">
            <div class="user-box-hint-label">
              <span>{{ $t('useBoxHint') }}:</span> {{ $t('useBoxHintTitle') }}</div>
            <div>
              <a @click="useHintVisible = true">{{ $t('detail') }}</a>
            </div>
          </div>
          <div class="hand-box-hint">
            <div class="hand-box-hint-label">
              <span>{{ $t('takeBoxHint') }}:</span> {{ $t('termsOfAgreementContent') }}</div>
            <div>
              <a @click="hintVisible = true">{{ $t('detail') }}</a>
            </div>
          </div>

        </a-card>
        <!--   提箱信息   -->
        <a-card class="order-detail-content">
          <div class="order-detail-title-border">
            <div class="order-detail-content-title">{{ $t('takeBoxInfo') }}</div>
            <!--   批量导入模板   -->
            <dol-button @click="downTemplateXeFile()" :title="$t('downloadLeaseTakeBoxTemplate')">
              <a-icon type="vertical-align-bottom"/>
            </dol-button>
          </div>
          <template v-if="xeList.length > 0" v-for="(item,index) in xeList">
            <dol-row :style="{backgroundColor: item.takeFlag ? '#F5F7F9' : '#F8F8F8' }" class="order-detail-collapse">
              <dol-col :span="8" class="order-detail-collapse-left">
                <div class="order-detail-collapse-code">{{ item.SEND_CODE }}</div>
                <div class="order-detail-collapse-yard">{{ $dt(item, 'SPACE_NAME') }}</div>
              </dol-col>
              <dol-col :span="5" class="order-detail-collapse-box" >
                <a-tag>{{$dt(item, 'BOX_SIZE_NAME')}}</a-tag> <span class="order-detail-collapse-box_num">x {{ item.REAL_QTY - item.TERM_QTY }}</span>
              </dol-col>
              <dol-col :span="8" class="order-detail-collapse-date">
                <div>
                  {{ $t('takeBoxIndate') }}
                  <a-popover v-if="item.DELAY_STATUS === 1 || item.DELAY_STATUS === 5" placement="top">
                    <template slot="content">
                      <div>{{ item.DELAY_QTY }}{{
                          $t('boxesHaveBeenAppliedForExtensionTo')
                        }}：{{ $moment(item.DELAY_END_DATE).format('MM-DD') }}
                      </div>
                      <div v-if="item.DELAY_STATUS === 1">{{ $t('status') }}：{{ $t('checkPending') }}</div>
                      <div v-if="item.DELAY_STATUS === 5">{{ $t('status') }}：{{ $t('通用_已拒绝') }}（{{ item.DELAY_DESC }}）</div>
                    </template>
                    <a-icon type="info-circle"/>
                  </a-popover>
                  <a-popover v-if="item.DELAY_STATUS === 2" placement="top">
                    <template slot="content">
                      <div>{{ item.DELAY_QTY }}{{$t('boxesHaveBeenPostponedTo') }}：{{ $moment(item.DELAY_END_DATE).format('MM-DD') }}</div>
                      <div>{{ $t('status') }}：{{ $t('通用_已同意') }}</div>
                    </template>
                    <a-icon type="check-circle"/>
                  </a-popover>
                </div>
                <div style="margin-top: 5px">{{ $moment(item.BEGIN_DATE).format('MM-DD') }}~{{$moment(item.END_DATE).format('MM-DD') }}</div>
              </dol-col>
              <dol-col :span="7" class="order-detail-collapse-status">
                <div class="order-detail-collapse-status_take" >
                  <template v-if="item.ORDER_QTY">
                    <div class="order-detail-collapse-status_take_circle"></div> <span> {{ $t('takeBox') }}（{{ item.ORDER_QTY }}）</span>
                  </template>
                  <template v-else>
                    <div class="order-detail-collapse-status_wait_circle"></div> <span> {{ $t('waitTakeBox') }}</span>
                  </template>
                </div>
              </dol-col>
              <dol-col :span="6">
                <a-space v-if="orderForm.OPER_STATUS !== 4" class="order-detail-collapse-button">
                  <dol-button :title="$t('viewDetails')" @click="detailsXeModal(item)">
                    <a-icon type="search"/>
                  </dol-button>
                  <dol-import :paramsData="{
                    SYS_TYPE: 20011003,
                    TARGET_CATE: 20021023,
                    TARGET_TYPE: 20071008,
                    TARGET_ID:orderForm.MASTER_ID,
                    GUID_CODE:''
                  }" :text="$t('uploadFiles')"
                              @finished="getOrderDetail(orderForm.MASTER_ID)"
                              :show-upload-list="false"
                              :accept="'.zip'"
                              :percent-flag="true"
                              serverType="2009">
                    <dol-button shape="circle" :title="$t('batchUploadPictures')" size="small">
                      <a-icon type="upload"/>
                    </dol-button>
                  </dol-import>
                  <dol-button v-if="xeFileMap[item.MASTER_ID + '20011002'] || xeFileMap[item.MASTER_ID + '20011001']"  @click="downloadXeFile(item)" :title="$t('downloadThePackingInstructions')">
                    <a-icon type="vertical-align-bottom"/>
                  </dol-button>
                  <a-space v-if="item.ORDER_QTY < item.REAL_QTY - item.TERM_QTY">
                    <dol-import  :showUploadList="false"
                                @finished="getOrderDetail(orderForm.MASTER_ID)"
                                :paramsData="{IMPORT_TYPE:20181016,MASTER_ID: item.MASTER_ID,}"
                                serverType="1010">
                      <dol-button shape="circle" :title="$t('batchExtraction')" size="small">
                        <a-icon type="project"/>
                      </dol-button>
                    </dol-import>
                    <!-- 去除限制【当堆场类型为平台协议时，客户不能录入箱号】， v-if="item.SEND_SPACE_TYPE = 20041002" -->
                    <dol-button @click="confirmXfBox(item)" key="2"
                                :title="$t('confirmTakeBox')">
                      <a-icon type="database"/>
                    </dol-button>
                    <dol-button v-if="item.DELAY_STATUS !== 1 && item.DELAY_STATUS !== 3" @click="openDelay(item,0)" :title="$t('applicationForExtension')">
                      <a-icon type="clock-circle" />
                    </dol-button>
                  </a-space>
                </a-space>
              </dol-col>
              <a-icon v-if="!item.takeFlag" @click="item.takeFlag = true" type="down" />
              <a-icon v-else @click="item.takeFlag = false" type="up" />
            </dol-row>
            <transition>
              <div class="order-detail-content-take" v-if="item.takeFlag">
                <div class="order-detail-content-take_title">{{ $t('takeBoxDetails') }}（{{ $t('通用_箱量') }}：{{ item.boxArr?.length }}）</div>
                <dol-list
                    class="collapse-dol-list"
                    :title="null"
                    :columns="takeColumns"
                    source="local"
                    :defaultData="item.boxArr"
                    :row-key="'FLOW_ID'"
                    :pagination="false"
                    :cardFlag="false"
                >
                  <template #BOX_CODE="field, record">
                    <div>
                      <img  class="box_img" :src="xfFileMap[record.FLOW_ID] && xfFileMap[record.FLOW_ID][0]?.FILE_NAME ? $Dolphin.path.filePath + xfFileMap[record.FLOW_ID][0].FILE_NAME : boxImg" />
                      <a-tag class="box_code">{{field}}</a-tag>
                    </div>
                  </template>
                  <template #SEND_DATE="field, record">
                    <div style="color: #666666">{{ $moment(record.XF_SEND_CHECK_DATE || record.TAKE_DATE).format('YYYY-MM-DD') }}</div>
                  </template>
                  <template #SEND_DRIVER="field, record">
                    <div style="color: #666666">{{field}} {{record.SEND_PERSON}} </div>
                    <div v-if="record.SEND_TRUCK" style="color: #666666">{{$t('licensePlate')}}: {{record.SEND_TRUCK}}</div>
                  </template>
                  <template #operation="field, record">
                    <a-space>
                      <dol-upload serverType="2009" :paramsData='{
                "SYS_TYPE": "20011003", //系统类型
                "TARGET_CATE": "20021017", //目标分类
                "TARGET_TYPE": "20071007", //目标类型
                "TARGET_ID": record.FLOW_ID,
                "GUID_CODE": ""
              }' :show-upload-list="false" @finished="getOrderDetail($route.query.MASTER_ID)">
                        <dol-button :title="$t('addPhotosOfSuitcases')">
                          <a-icon type="camera" />
                        </dol-button>
                      </dol-upload>
                      <dol-button @click="openXfModal(record)" :title="$t('viewDetails')">
                        <a-icon type="file-search" />
                      </dol-button>
                    </a-space>
                  </template>
                </dol-list>
              </div>
            </transition>
          </template>
          <a-empty :description="false" v-else/>
        </a-card>
        <!--   运输信息   -->
<!--        <cargo-transport :elTransportList="transportList" :elBoxList="BOX_LIST" :orderForm="orderForm" :transTypeList="transTypeList" @getOrderDetail="getOrderDetail" />-->
        <a-card class="order-detail-content">
          <div class="order-detail-title-border">
            <div class="order-detail-content-title">{{ $t('oldTransportInfo') }}</div>
            <a-button v-if="BOX_LIST.length > 0" @click="oldAddTrans(0)" class="order-detail-content-add_button">
              <a-icon type="plus"/>
              {{ $t('addInfo') }}
            </a-button>
          </div>
          <div style="margin-top: 12px;" v-if="sheetList.length > 0">
            <a-row :gutter="[12,12]" class="order-detail-transport-content">
              <a-col :span="12" v-for="(item,index) in sheetList" :key="index">
                <div class="order-detail-transport-content_border">
                  <div class="order-detail-transport-ship_name">
                    <div class="order-detail-transport-ship_box">{{ $dt(item, 'SHIP_NAME') }}({{ $t('通用_箱量') }}×{{
                        item.BOX_CODE_ARR.length
                      }})
                    </div>
                    <a-space>
                      <dol-button v-if="item.GUID_CODE" @click="downTransFile(item)"
                                  :title="$t('downTransFile')">
                        <a-icon type="vertical-align-bottom"/>
                      </dol-button>
                      <dol-upload :showUploadList="false" @finished="getOrderDetail($route.query.MASTER_ID)"
                                  v-if="item.FLOW_ID" :paramsData="{
                    SYS_TYPE: 20011003,
                    TARGET_CATE: 20021020,
                    TARGET_TYPE: 20071007,
                    TARGET_ID: item.FLOW_ID,
                    GUID_CODE: item.GUID_CODE
                }" serverType="2009">
                        <dol-button :title="$t('updateTransFile')">
                          <a-icon type="vertical-align-top"/>
                        </dol-button>
                      </dol-upload>
                      <dol-button @click="oldAddTrans(1,item)">
                        <a-icon type="form"/>
                      </dol-button>
                      <dol-button @click="removeTransport(item)">
                        <a-icon style="color: #999999;" type="close-circle"/>
                      </dol-button>
                    </a-space>
                  </div>
                  <div class="order-detail-transport-box-code">
                    <div>{{
                        item.SHIP_TYPE === 20061001 || item.SHIP_TYPE === 20061003 ? $t('BLNO') : $t('sweepNumber')
                      }}：{{ item.SHIP_CODE }}
                    </div>
                    <div v-if="item.SHIP_TYPE === 20061001  || item.SHIP_TYPE === 20061003">{{
                        $t('vesselVoyage')
                      }}：{{ $dt(item, 'SHIP_NAME') }}
                    </div>
                  </div>
                  <div class="order-detail-transport-box-shift">
                    <div>{{ $t('transportationType') }}：
                      <dol-dict :option="item.SHIP_TYPE" code="2006"/>
                    </div>
                  </div>
                  <div class="order-detail-transport-box-shift-code">
                    <div class="shift-code" v-for="(boxCode,index) in item.BOX_CODE_ARR" :key="index">
                      {{ boxCode.BOX_CODE }}
                    </div>
                  </div>
                </div>
              </a-col>
            </a-row>
          </div>
          <a-empty :description="false" v-else/>
        </a-card>
        <!--   异地还箱申请列表     -->
        <diff-city-return-list :sheet-data="sheetData" @reload="getOrderDetail" ref="diffCityReturnList" />
        <!--   还箱申请   -->
        <cargo-apply-return-list :sheet-data="sheetData" :order-form="orderForm" :box-list="BOX_LIST" :show-data="xgList" @reload="getOrderDetail" ref="cargoApplyReturnList" />

        <!--   还箱指令   -->
        <a-card class="order-detail-content">
          <div class="order-detail-title-border">
            <div class="order-detail-content-title">{{ $t('returnBoxInstructionsList') }}</div>
          </div>
          <template v-if="xhList.length > 0">
            <div v-for="(item,index) in xhList" :key="index">
              <dol-row :style="{backgroundColor: item.xhFlag ? '#F5F7F9' : '#F8F8F8' }" class="order-detail-collapse">
                <dol-col :span="10" class="order-detail-collapse-left">
                  <div class="order-detail-collapse-code">{{ $dt(item, 'RET_SPACE_NAME') }}</div>
                  <div class="order-detail-collapse-yard">{{ $t('stackPosition') }}: {{item.CUST_CODE}}</div>
                </dol-col>
                <dol-col :span="8" class="order-detail-collapse-box_return_num" >
                  {{item.RET_BOX_NUM}}/{{item.BOX_NUM}}
                </dol-col>
                <dol-col :span="10" class="order-detail-collapse-status">
                  <div class="order-detail-collapse-status_ret" >
                    <template v-if="item.RET_BOX_NUM === 0">
                      <div class="order-detail-collapse-status_ret_wait_circle"></div>
                      <span> {{ $t('waitReturnBox') }}</span>
                    </template>
                    <template v-else-if="item.RET_BOX_NUM < item.BOX_NUM">
                      <div class="order-detail-collapse-status_ret_reting_circle"></div>
                      <span> {{ $t('returningBox') }}</span>
                    </template>
                    <template v-else>
                      <div class="order-detail-collapse-status_ret_finish_circle"></div>
                      <span> {{ $t('boxReturnCompleted') }}</span>
                    </template>
                  </div>
                </dol-col>
                <dol-col :span="4">
                  <a-space>
                    <dol-button :title="$t('applicationForExtension')" @click="openXhDelay(item,true)">
                      <a-icon type="clock-circle"/>
                    </dol-button>
                    <dol-button v-if="xhFileMap[item.MASTER_ID + '20011002']" :title="$t('returnBoxInstructions')" @click="downloadXhFile(item)">
                      <a-icon type="vertical-align-bottom"/>
                    </dol-button>
                    <dol-button v-else-if="xhFileMap[item.MASTER_ID + '20011001']" :title="$t('returnBoxInstructions')"
                                @click="downloadXhFile(item)">
                      <a-icon type="vertical-align-bottom"/>
                    </dol-button>
                  </a-space>
                </dol-col>
                <a-icon v-if="!item.xhFlag" @click="item.xhFlag = true" type="down" />
                <a-icon v-else @click="item.xhFlag = false" type="up" />
              </dol-row>
              <transition>
              <div class="order-detail-content-take" v-if="item.xhFlag">
                <div class="order-detail-content-take_title">{{ $t('takeBoxDetails') }}（{{ $t('通用_箱量') }}：{{ item.boxArr?.length }}）</div>
                <dol-list
                    class="collapse-dol-list"
                    :title="null"
                    :columns="xhColumns"
                    source="local"
                    :defaultData="item.boxArr"
                    :row-key="'FLOW_ID'"
                    :pagination="false"
                    :cardFlag="false"
                >
                  <template #BOX_CODE="field, record">
                    <div>
                      <img  class="box_img" :src="boxImg" />
                      <a-tag class="box_code">{{field}}</a-tag>
                    </div>
                  </template>
                  <template #BEGIN_DATE="field, record">
                    <span style="color: #666666">{{$moment(record.BEGIN_DATE).format('YYYY-MM-DD') }}~{{ $moment(record.END_DATE).format('YYYY-MM-DD') }}</span>
                  </template>
                  <template #RET_DATE="field, record">
                    <div style="color: #666666">{{ (record.RET_CHECK_DATE || record.RET_DATE) ? $moment(record.RET_CHECK_DATE || record.RET_DATE).format('YYYY-MM-DD') : ''}}</div>
                  </template>
                  <template #RET_STATUS="field, record">
                    <span style="color: #52c41a;" v-if="record.RET_STATUS === 10">{{ $t('finished') }}</span>
                    <span style="color: #999999;" v-if="record.RET_STATUS === 9">{{ $t('cancellationText') }}</span>
                    <div :style="getDelayStyle(record)" v-if="record.RET_STATUS === 6">
                      <div>{{ $t('cargoApplyExtension') }}</div>
                      <div>{{ $t('delayReason') }}:{{ record.DELAY_DESC }}</div>
                      <div>{{ $t('delayTime') }}:{{ record.DELAY_END_DATE ? $moment(record.DELAY_END_DATE).format('YYYY-MM-DD') : '' }}</div>
                    </div>
                  </template>
                  <template #operation="field, record">
                    <a-space>
                      <dol-button
                        v-if="record.RET_STATUS === 3 || record.RET_STATUS === 7"
                        :title="$t('applicationForExtension')"
                        @click="openXhDelay(record, false)"
                      >
                        <a-icon type="clock-circle"/>
                      </dol-button>
                      <dol-button class="card-button" :title="$t('confirmReturnBox')" shape="circle" size="small"
                                  v-if="!/4|9|10/.test(record.RET_STATUS)" @click="openXhModal(record)">
                        <a-icon type="check"/>
                      </dol-button>
                      <dol-upload v-if="record.XH_FILE_GUID_CODE" :showUploadList="false"
                                  @finished="getOrderDetail($route.query.MASTER_ID)" :paramsData="{
                                    SYS_TYPE: 20011003,
                                    TARGET_CATE: 20021011,
                                    TARGET_TYPE: 20071003,
                                    TARGET_ID: record.FLOW_ID,
                                    GUID_CODE: record.XH_FILE_GUID_CODE
                                  }" serverType="2009">
                        <dol-button :title="$t('changeReturnBoxDocuments')">
                          <a-icon type="solution" />
                        </dol-button>
                      </dol-upload>
                      <dol-upload v-if="!record.XH_FILE_GUID_CODE && record.RET_STATUS === 10 " :showUploadList="false"
                                  @finished="getOrderDetail($route.query.MASTER_ID)" :paramsData="{
                    SYS_TYPE: 20011003,
                    TARGET_CATE: 20021011,
                    TARGET_TYPE: 20071003,
                    TARGET_ID: record.FLOW_ID,
                    GUID_CODE: ''
                }" serverType="2009">
                        <dol-button :title="$t('uploadReturnBoxDocuments')">
                          <a-icon type="solution" />
                        </dol-button>
                      </dol-upload>
                      <dol-button v-if="record.XH_FILE_GUID_CODE"
                                  @click="downXhCargoFile(record)"
                                  :title="$t('downloadReturnBoxDocuments')">
                        <a-icon type="vertical-align-bottom"/>
                      </dol-button>
                    </a-space>
                  </template>
                </dol-list>
              </div>
            </transition>
            </div>
          </template>
          <a-empty :description="false" v-else/>
        </a-card>
        <!--   集装箱列表     -->
        <a-card class="order-detail-content order-detail-content-list">
          <dol-list
              :title="$t('detailsOfContainers')"
              class="dol-list-style"
              :columns="boxColumns"
              source="local"
              :defaultData="BOX_LIST"
              :row-key="'BOX_ID'"
              :pagination="false"
              :selected-row-keys.sync="selectedRowKeys"
              :selected-rows.sync="selectedRows"
              :selection-get-checkbox-props="record => ({props: {disabled: !record.MASTER_ID}})"
              ref="list"
          >
            <template #extra>
              <a-button :disabled="selectedRows.length <= 0" @click="openAllConfirmXhOrder()" type="primary">
                {{ $t('batchReturnBox') }}
              </a-button>
            </template>
            <template #operation="field, record">
              <a-space>
                <dol-button type="link" :title="$t('boxError')"
                            @click="openBoxErrorModal(record)">
                  <a-icon type="warning" style="color: #FF0000"/>
                </dol-button>
                <dol-button type="link" @click="openBoxHistoryModal(record.BOX_ID)" :title="$t('boxTracking')">
                  <a-icon type="bars"/>
                </dol-button>
              </a-space>
            </template>
            <template #SEND_DATE="field, record">
              <div>{{ $moment(field).format('YYYY-MM-DD') }}</div>
            </template>
            <template #RET_DATE="field, record">
              <div v-if="field && record.RET_STATUS != 3">
                {{ $moment(field).format('YYYY-MM-DD') }}
              </div>
              <div v-else>{{ $t('noReturnBox') }}</div>
              <div style="color: #999999" v-if="record.extraDays > 0">{{ `${$t('surplus')}${record.extraDays}${$t('day')}` }}</div>
              <div :style="record.extraDays < 0 ? 'color: red;': ''"
                   v-if="record.BOX_DELAY_STATUS || record.extraDays < 0">
                {{ record.extraDays > 0 ? '' : `${$t('hasExpired')}${Math.abs(record.extraDays)}${$t('day')}` }}
              </div>
              <div v-if="record.BOX_DELAY_STATUS && record.BOX_DELAY_AMT">
                {{ $t('detentionCharge') }}：{{ record.BOX_DELAY_AMT }}
              </div>
            </template>
          </dol-list>
        </a-card>
        <!--   异常集装箱     -->
        <a-card class="order-detail-content order-detail-content-list" style="margin-bottom: 0;padding-top: 24px;">
          <dol-list
              class="order-detail-content order-detail-content-list" style="margin-bottom: 0;"
              :title="$t('boxErrorList')"
              :columns="unBoxColumns"
              source="local"
              :pagination="false"
              :defaultData="BOX_EX_LIST"
              :row-key="'BOX_ID'"
              ref="list"
          >
            <template #operation="field, record">
              <a-space>
                <!--                <a v-if="!record.BOX_EX_STATUS" :title="$t('boxError')" @click="openBoxErrorModal(record)">
                                  {{$t('boxError')}}
                                </a>-->
                <dol-button :title="$t('detail')" @click="openBoxDetailModal(record)">
                  <a-icon type="search"/>
                </dol-button>
              </a-space>
            </template>
            <template #BOX_EX_RESULT="field, record">
              <div v-if="record.BOX_EX_RET_DATE">
                <div>{{ $t('processMode') }}:{{ $t('instantReturnBox') }}</div>
                <div>{{ $t('通用_堆场') }}: {{ $dt(record, 'SPACE_NAME') }}(
                  <dol-dict :option="record.BOX_EX_RET_SPACE_TYPE" code="2004"/>
                  )
                </div>
                <div>{{ $t('returnBoxTime') }}: {{ $moment(record.BOX_EX_RET_DATE).format('YYYY-MM-DD') }}</div>
                <div>{{ $t('通用_备注') }}: {{ record.BOX_EX_MEMO }}</div>
              </div>
              <div v-else>{{ field }}</div>
            </template>
          </dol-list>
        </a-card>
      </dol-col>

      <dol-col class="order-detail-right">
        <a-card>
          <div class="manager-order-status" v-if="orderForm.OPER_STATUS === 4">
            <span
                :style="{color: orderForm.OPER_STATUS === 4 ? 'red':'green'}">{{
                $dt(orderForm, 'OPER_STATUS_NAME')
              }}</span>
          </div>
          <div class="order-detail-right-title">{{ $t('orderPaymentDetails') }}</div>
          <div class="order-detail-right-target">{{ $dt(orderForm, 'CITY_NAME') }}
            <a-icon style="margin: 0 8px;color: #666666" type="swap-right"/>
            {{ $dt(orderForm, 'D_CITY_NAME') }}
          </div>
          <a-descriptions class="order-detail-right-descriptions"
                          :layout="$i18n.locale === 'zh'?'horizontal':'vertical'" :column="1" :size="'small'">
            <a-descriptions-item>
              <template slot="label">
               {{ $t('通用_箱型') }}
              </template>
              <span>{{ $dt(orderForm, 'BOX_SIZE_NAME') }}</span>
            </a-descriptions-item>
            <a-descriptions-item>
              <template slot="label">
                {{ $t('planUseBox') }}
              </template>
              <span>{{ this.$moment(orderForm.ESTIM_DATE).format('YYYY-MM-DD') }}</span>
            </a-descriptions-item>
            <a-descriptions-item>
              <template slot="label">
               {{ $t('通用_箱量') }}
              </template>
              <span>
                {{ orderForm.SHEET_QTY }}
                <dol-button :title="$t('租赁单_申请减少箱量')" v-if="orderForm.OPER_STATUS !== 4" @click="$refs.reduceNumberModal.open(orderForm)" >
                  <a-icon type="minus" />
                </dol-button>
              </span>
            </a-descriptions-item>
            <a-descriptions-item>
              <template slot="label">
                {{ $t('boxWeight') }}
              </template>
              <span>{{ orderForm.UNIT_WEIGHT || 0 }}{{ $t('ton') }}</span>
            </a-descriptions-item>
            <a-descriptions-item>
              <template slot="label">
               {{ $t('goodsType') }}
              </template>
              <span>{{ $dt(orderForm, 'GOODS_TYPE_NAME') }}</span>
            </a-descriptions-item>
            <a-descriptions-item>
              <template slot="label">
                {{ $t('goodsName') }}
              </template>
              <span>{{ orderForm.GOODS_NAME }}</span>
            </a-descriptions-item>
            <a-descriptions-item>
              <template slot="label">
                {{ $t('通用_客户订单号') }}
              </template>
              <span>{{ orderForm.CUST_CODE }}</span>
            </a-descriptions-item>
            <a-descriptions-item>
              <template slot="label">
                {{ $t('vesselVoyage') }}
              </template>
              <span>{{ xbOrderMaster.SHIP_NN }}</span>
            </a-descriptions-item>
          </a-descriptions>
          <div style="margin-bottom: 8px">
            <span style="margin: 0 8px 0px 2px;color: #333333">{{ $t('通用_备注') }} :</span>
            <span>{{ orderForm.MEMO || '- -' }}</span>
          </div>
          <div>
            <span style="margin: 0 8px 0 2px;color: #333333">{{ $t('通用_申请备注') }} :</span>
            <span>{{ orderForm.XB_MEMO || '- -' }}</span>
          </div>
          <div class="box-total-price">
            <div class="box-total-price-title">{{ $t('myBill') }}:</div>
          </div>
          <div class="box-total-price-content" v-if="chargePriceTotal.length>0">
            <div class="box-total-price-content-box" v-for="(item,index) in chargePriceTotal" :key="index">
              <span>{{ item && $dt(item, 'CURRENCY_NAME') }}</span>
              <div>{{ item.SYMBOL }}{{priceList?.[0].CURRENCY_ID === item.CURRENCY_ID ? priceList?.[0]?.SHEET_AMT + item.AMT : item.AMT}}</div>
            </div>
          </div>
          <div class="box-total-price-content" v-else>
            <div class="box-total-price-content-box">
              <span>{{ priceList[0] && $dt(priceList[0], 'CURRENCY_NAME') }}</span>
              <div class="box-total-price-content-box_price">{{ priceList?.[0]?.SYMBOL }}{{ priceList?.[0]?.SHEET_AMT || 0 }}</div>
            </div>
          </div>
          <div class="box-price-from">
            <div v-for="item in priceList" class="box-price-from-line">
              <div>{{ $dt(item, 'BOX_STATE_NAME') }}</div>
              <div><span style="margin-right: 20px">{{ item.SYMBOL }}{{ item.VALID_PRICE }}/{{
                  $t('box')
                }}</span>×{{ item.REAL_QTY }}
              </div>
            </div>
            <div class="box-price-sum">
              <div>{{ $t('boxRentalFees') }} {{ priceList && priceList[0]?.SYMBOL }}{{ priceList && priceList[0]?.SHEET_AMT }}</div>
            </div>
            <div class="box-price-pay">
              <div  :style="orderForm.ACCT_STATUS ? 'color: #00B87B':'color: #EE5142'">
                <dol-dict :option="orderForm.PAY_TYPE" code="1007"/>
                <span>({{orderForm.ACCT_STATUS ? $t('paid') : $t('notPaid')}})</span>
              </div>
            </div>
          </div>
          <a-divider type="horizontal" style="margin: 16px 0" dashed/>
          <div class="box-delay-price" v-if="CHARGE_LIST.length > 0">
            <div class="box-delay-price-sum">
              <div>{{ $t('additionalExpense') }}</div>
            </div>
            <div class="box-delay-price-line" v-for="(priceItem,index) in CHARGE_LIST_MAP" :key="index">
              <h4>{{ $dt(priceItem[0], 'CHARGE_NAME') }}</h4>
              <div style="display: flex;justify-content: space-between;" v-for="(item,index) in priceItem" :key="index">
                <a-space>
                  <div>{{ item.BOX_CODE }}</div>
                  <div v-if="item.FILE_LIST" @click="openImageModal(item.FILE_LIST)">
                    <a-icon style="color: #1C62A9;cursor: pointer;" type="picture"/>
                  </div>
                </a-space>
                <div>{{ item.ACCT_TYPE === 0 ? '-' : '' }}{{ item.SYMBOL }}{{ item.AMT }}</div>
              </div>
            </div>
          </div>
        </a-card>
      </dol-col>

      <!--交箱条款-->
      <a-modal class="use-box-modal" v-model.trim="hintVisible" :okText="$t('confirm')" :cancelText="$t('cancel')"
               centered
               width="60%" :title="$t('takeBoxHint')">
      <pre class="use-box-detail">{{
          $t('termsOfAgreementContent')
        }}</pre>
        <template slot="footer">
          <a-button type="primary" @click="hintVisible = false">{{ $t('iHaveKnown') }}</a-button>
        </template>
      </a-modal>

      <!--用箱条款-->
      <a-modal class="use-box-modal" v-model.trim="useHintVisible" :okText="$t('confirm')" :cancelText="$t('cancel')"
               centered
               width="60%" :title="$t('useBoxHint')">
      <pre class="use-box-detail">{{
          $t('useBoxHintTitle')
        }}</pre>
        <template slot="footer">
          <a-button type="primary" @click="useHintVisible = false">{{ $t('iHaveKnown') }}</a-button>
        </template>
      </a-modal>

      <!--放箱单延期-->
      <a-modal v-model.trim="deferVisible" centered width="60%" :okText="$t('confirm')" :cancelText="$t('cancel')"
               :title="$t('putBoxOrderPostpone')"
               @ok="confirmDelay"
               @cancel="deferForm={}"
               destroyOnClose>
        <dol-form-model :model="deferForm" :rules="deferValidateRules" ref="deferForm">
          <a-row>
            <a-col :span="11">
              <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}"
                                 :label="$t('postponeBoxNum')" prop="DELAY_QTY">
                <a-input-number :max="orderForm.SHEET_QTY - deferForm.ORDER_QTY" :min="1"
                                :placeholder="$t('pleaseEnterTheNumberOfBoxes')" v-model.trim="deferForm.DELAY_QTY"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="11" :offset="2">
              <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}"
                                 :label="$t('extensionDate')"
                                 prop="DELAY_END_DATE">
                <dol-date :placeholder="$t('pleaseSelectADate')"
                          v-model.trim="deferForm.DELAY_END_DATE" style="width: 100%"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col>
              <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}"
                                 :label="$t('delayReason')" prop="DELAY_DESC">
                <a-textarea
                    v-model.trim="deferForm.DELAY_DESC"
                    :placeholder="$t('IssueNumber')"
                    :auto-size="{ minRows: 3, maxRows: 10 }"
                />
              </a-form-model-item>
            </a-col>
          </a-row>
        </dol-form-model>
      </a-modal>

      <!--  提箱确认  -->
      <a-modal class="order-fetch-modal" v-model.trim="xfShow" centered width="60%" :okText="$t('confirm')"
               :cancelText="$t('cancel')"
               :title="$t('takeBoxOrder')"
               destroyOnClose @ok="confirmXfOrder" @cancel="cancelXfModel">
        <div class="order-fetch-modal-title">【{{ $dt(orderForm, 'CITY_NAME') }}】{{
            $dt(orderForm, 'SPACE_NAME')
          }}（{{ $dt(orderForm, 'BOX_SIZE_NAME') }} ×
          {{ xfForm.REAL_QTY - xfForm.PICK_QTY - xfForm.TERM_QTY  }}）
        </div>
        <dol-form-model>
          <div class="order-fetch-list">
            <div class="order-fetch-list-box" v-for="(item,index) in xfBoxList" :key="index">
              <a-row style="display: flex;align-items: center;background: #F8F8F8;padding: 14px" :gutter="16">
                <a-col :span="22">
                  <a-row type="flex" justify="space-between">
                    <a-col :span="7">
                      <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" :label="$t('driverName')"
                                         prop="SEND_DRIVER">
                        <a-input v-model.trim="item.SEND_DRIVER"/>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="7">
                      <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" :label="$t('contactWay')"
                                         prop="SEND_PERSON">
                        <a-input v-model.trim="item.SEND_PERSON"/>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="7">
                      <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" :label="$t('licensePlate')"
                                         prop="SEND_TRUCK">
                        <a-input v-model.trim="item.SEND_TRUCK"/>
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="11">
                      <a-form-model-item
                          :validate-status="item.TAKE_DATE ? 'success': 'error'"
                          :help="item.TAKE_DATE ? '': $t('thePickupTimeMustNotBeEmpty')"
                          :labelCol="{span: 24}" :wrapperCol="{span: 24}" :label="$t('TakeBoxTime')" prop="TAKE_DATE">
                        <dol-date :placeholder="$t('pleaseSelectADate')" v-model.trim="item.TAKE_DATE"
                                  :disabled-date="v => $moment().endOf('day').isBefore(v)"
                                  style="width: 100%"/>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="11" :offset="2">
                      <a-form-model-item
                          :validate-status="item.BOX_CODE ? 'success': 'error'"
                          :help="item.BOX_CODE ? '': $t('theContainerNumberCannotBeEmpty')"
                          :labelCol="{span: 24}" :wrapperCol="{span: 24}" :label="$t('通用_箱号')">
                        <a-input v-model.trim="item.BOX_CODE"/>
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col>
                      <dol-upload-img-list :max="6" :paramsData="xfParamsData" style="margin-top: 10px;"
                                           :placeholder="$t('pictureOfContainer')" serverType="2009"
                                           v-model.trim="item.GUID_CODES"></dol-upload-img-list>
                    </a-col>
                  </a-row>
                </a-col>
                <a-col :span="2" style="display: flex;justify-content: center;">
                  <div @click="deleteXfItem(index)">
                    <a-icon style="color: #FF0000;font-size: 24px;" type="delete"/>
                  </div>
                </a-col>
              </a-row>
            </div>
            <div class="order-fetch-add" v-if="xfBoxList.length < xfForm.REAL_QTY - xfForm.PICK_QTY - xfForm.TERM_QTY" style="">
              <a @click="addXfItem">
                <a-icon type="plus" style="margin-right: 5px;"/>
                {{ $t('addSuitcaseInformation') }}</a>
            </div>
          </div>
        </dol-form-model>
      </a-modal>

      <!--提箱单详情-->
      <a-modal class="xf-detail-model" v-model.trim="xfDetailShow" centered width="50%"
               :title="$t('packingListDetails')"
               :footer="false">
        <table>
          <tr>
            <th colspan="6">{{ $t('takeBoxPlace') }}</th>
            <th colspan="6">{{ $t('通用_还箱地') }}</th>
          </tr>
          <tr>
            <td colspan="6">{{ $dt(xfForm, 'CITY_NAME') }}</td>
            <td colspan="4">{{ $dt(xfForm, 'D_CITY_NAME') }}</td>
          </tr>
          <tr>
            <th colspan="12">{{ $t('formContainerNumber') }}</th>
          </tr>
          <tr>
            <td colspan="12">
              <span>
                   <a-tag style="margin: 3px" color="blue">
                     {{ xfForm.BOX_CODE }}
                   </a-tag>
              </span>
            </td>
          </tr>

          <tr>
            <td colspan="3">{{ $t('formFreeContainerPeriod') }}</td>
            <td colspan="3">{{ $t('formEstimatedPckupDate') }}</td>
            <td colspan="2" rowspan="2">{{ $t('通用_箱型') }}</td>
            <td colspan="2" rowspan="2">{{ $t('通用_箱量') }}</td>
          </tr>

          <tr>
            <td colspan="3">{{ orderForm.USE_DAYS }}{{ $t('day') }}</td>
            <td colspan="3">{{ $moment(xfForm.ESTIM_DATE).format('YYYY-MM-DD') }}</td>
          </tr>
          <tr>
            <td colspan="3">{{ $t('driverName') }}</td>
            <td colspan="3">{{ $t('formActualPickupDate') }}</td>
            <td colspan="2" rowspan="4">{{ $dt(orderForm, 'BOX_SIZE_NAME') }}</td>
            <td colspan="2" rowspan="4">1</td>
          </tr>
          <tr>
            <td colspan="3">{{ xfForm.SEND_DRIVER }}</td>
            <td colspan="3">{{ $moment(xfForm.TAKE_DATE).format('YYYY-MM-DD') }}</td>
          </tr>
          <tr>
            <td colspan="3">{{ $t('formDriverPhone') }}</td>
            <td colspan="3">{{ $t('formSuitcaseCarNumber') }}</td>
          </tr>
          <tr>
            <td colspan="3">{{ xfForm.SEND_PERSON }}</td>
            <td colspan="3">{{ xfForm.SEND_TRUCK }}</td>
          </tr>
          <tr>
            <th colspan="10">
              <dol-image-list-preview :remove-icon="true" :imageList="xfFileMap[xfForm.FLOW_ID]"
                                      @removeFile="removeFile"></dol-image-list-preview>
            </th>
          </tr>
          <tr>
            <th colspan="2">{{ $t('formMemo') }}</th>
            <th colspan="8">
              {{ xfForm.MEMO }}
            </th>
          </tr>
          <tr>
            <th colspan="10">{{ $t('takeBoxCyName') }}</th>
          </tr>
          <tr>
            <td colspan="10">{{ $dt(xfForm, 'SEND_SPACE_NAME') }}</td>
          </tr>
          <tr>
            <th colspan="10">{{ $t('formYardAddressAndContactInformation') }}</th>
          </tr>
          <tr>
            <td colspan="10">
              <div>{{ xfForm.ADDRESS }}</div>
              <div>{{ xfForm.SEND_SPACE_PERSON }}</div>
            </td>
          </tr>
        </table>
      </a-modal>

      <!--选择路线模板-->
      <a-modal v-model.trim="selectTemplateShow" centered width="720px" :footer="null"
               :title="$t('selectRouteTemplate')" destroyOnClose @cancel="closeTrans">
        <div v-for="(item,index) in transTemplateList" :key='index' class="trans-template-list"
             @click="confirmTemplate(item.MASTER_ID,orderForm.MASTER_ID,orderForm.SHEET_CODE)">
          <div class="trans-template-line">
            <template v-for="(detail,index1) in item.TA_DETAIL">
              <div class="trans-template-line__site">
                <div class="trans-template-line__site__title">
                  <div class="trans-template-line__site__title__if" v-if="index1 === 0"><img
                      class="trans-template-line__site__title__icon"
                      src="../../../public/static/icon/takeCityLogo.svg"/>{{ $t('takeBoxPlace') }}
                  </div>
                  <div class="trans-template-line__site__title__if" v-else><img
                      class="trans-template-line__site__title__icon"
                      src="../../../public/static/icon/transferStation.svg"/>{{ $t('transferStation') }}
                  </div>
                </div>
                {{ $dt(detail, 'CITY_NAME') }}
              </div>
              <div class="trans-template-line__dot-line"></div>
              <div class="trans-template-line__icon">
                <img v-if="detail.SHIP_TYPE === 20061002" style="width: 32px"
                     src="../../../public/static/icon/railTrans.svg"/>
                <img v-else style="width: 32px" src="../../../public/static/icon/seaTrans.svg"/>
              </div>
              <div class="trans-template-line__dot-line"></div>
              <div class="trans-template-line__site" v-if="index1 !== 0">
                <div class="trans-template-line__site__title"><img class="trans-template-line__site__title__icon"
                                                                   src="../../../public/static/icon/returnCityLogo.svg"/>{{ $t('通用_还箱地') }}
                </div>
                {{ $dt(detail, 'D_CITY_NAME') }}
              </div>
            </template>
          </div>
        </div>
      </a-modal>

      <!--运输信息-->
      <a-modal v-model.trim="oldTransportShow" centered width="60%" :okText="$t('confirm')" :cancelText="$t('cancel')"
               :title="$t('transportInfo')" destroyOnClose @ok="oldSaveTransport"
               @cancel="closeTrans">
        <dol-form-model :model="transForm" :rules="transValidateRules" ref="transForm">
          <a-row>
            <a-col :span="11">
              <a-form-model-item :label="$t('transportationType')" :labelCol="{span: 24}" :wrapperCol="{span: 24}"
                                 prop="SHIP_TYPE">
                <a-radio-group v-model.trim="transForm.SHIP_TYPE">
                  <template v-for="item in transTypeList">
                    <a-radio :value="item.code">
                      {{ $dt(item, 'text') }}
                    </a-radio>
                  </template>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <a-col :span="11" offset="2">
              <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" :label="$t('uploadFiles')"
                                 v-if="!transForm.FLOW_ID"
                                 prop="GUID_CODES">
                <dol-upload @finished="transFinished" :paramsData="oldTransParamsData" :text="$t('uploadFiles')"
                            serverType="2009" v-model.trim="transForm.GUID_CODES"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="11">
              <a-form-model-item
                  :label="transForm.SHIP_TYPE === '20061001' || transForm.SHIP_TYPE === '20061003' ? $t('BLNO') : $t('sweepNumber') "
                  :labelCol="{span: 24}" :wrapperCol="{span: 24}" prop="SHIP_CODE">
                <a-input v-model.trim="transForm.SHIP_CODE"/>
              </a-form-model-item>
            </a-col>
            <a-col v-if="transForm.SHIP_TYPE === '20061001' || transForm.SHIP_TYPE === '20061003'" :span="11"
                   :offset="2">
              <a-form-model-item :label="$t('vesselVoyage')" :labelCol="{span: 24}"
                                 :wrapperCol="{span: 24}" prop="SHIP_NAME">
                <a-auto-complete
                    v-model.trim="transForm.SHIP_NAME"
                    @select="getShipName"
                    @change="getShipNameList"
                >
                  <template slot="dataSource">
                    <a-select-opt-group v-if="shipNameList.length>0" :key="1">
                        <span slot="label">
                              <a-pagination style="position: absolute;right: 4px" v-model.trim="current" :total="total"
                                            show-less-items @change="getShipNameList"/>
                        </span>
                      <a-select-option v-for="name in shipNameList" :key="name">
                        {{ name }}
                      </a-select-option>
                    </a-select-opt-group>
                  </template>
                </a-auto-complete>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col>
              <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" prop="SHIP_DETAIL">
                <template #label>
                  <span>{{ $t('pleaseSelectTheCaseNumber') }}</span>
                  <a-checkbox @change="oldCheckAllTrans">{{ $t('selectAll') }}</a-checkbox>
                </template>
                <div style="border: 1px solid #eeeeee;border-radius: 4px;padding: 10px 20px;line-height: 1;">
                  <a-checkbox-group v-model.trim="transForm.SHIP_DETAIL" :options="boxOptions"></a-checkbox-group>
                </div>
              </a-form-model-item>
            </a-col>
          </a-row>
        </dol-form-model>
      </a-modal>

      <!--  确认还箱  -->
      <a-modal v-model.trim="xhShow" centered width="60%" :okText="$t('confirm')" :cancelText="$t('cancel')"
               :title="$t('confirmReturnBox')" @ok="confirmXhOrder" @cancel="xhForm = {}">
        <dol-form-model :model="xhForm" :rules="xhOrderValidateRules" ref="xhForm">
          <a-row>
            <a-col :span="11">
              <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" :label="$t('returnBoxTime')"
                                 prop="RET_DATE">
                <dol-date :placeholder="$t('pleaseSelectADate')" :disabled-date="v => $moment().endOf('day').isBefore(v)" v-model.trim="xhForm.RET_DATE" style="width: 100%"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="11" offset="2">
              <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" :label="$t('returnBoxDocuments')">
                <dol-upload @finished="xhFinished" :paramsData="xhParamsData" :text="$t('uploadReturnBoxDocuments')"
                            serverType="2009" v-model.trim="xhForm.GUID_CODES"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" :label="$t('returnBoxConfirmExplain')"
                                 prop="SEND_CHECK_DESC">
                <a-textarea
                    v-model.trim="xhForm.SEND_CHECK_DESC"
                    :placeholder="$t('IssueNumber')"
                    :auto-size="{ minRows: 3 }"
                />
              </a-form-model-item>
            </a-col>
          </a-row>
        </dol-form-model>
      </a-modal>

      <!--  还箱指令延期  -->
      <a-modal v-model.trim="xhDeferVisible" centered width="60%" :okText="$t('confirm')" :cancelText="$t('cancel')"
               :title="$t('returnBoxOrderPostpone')"
               @ok="confirmXhDelay" @cancel="xhDeferForm = {}" destroyOnClose>
        <dol-form-model :model="xhDeferForm" :rules="xhDeferValidateRules" ref="xhDeferForm">
          <a-row>
            <a-col :span="11">
              <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}"
                                 :label="$t('通用_箱号')">
                <a-checkbox-group v-if="xhDeferForm.xhDelayFlag" v-model.trim="xhDeferForm.BOX_CODE_ARR" :options="xhDeferForm.boxArr"></a-checkbox-group>
                <a-tag v-else>{{ xhDeferForm.BOX_CODE }}</a-tag>
              </a-form-model-item>
            </a-col>
            <a-col :span="11" :offset="2">
              <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}"
                                 :label="`${$t('postpone')}${$t('通用_日期')}`"
                                 prop="DELAY_END_DATE">
                <dol-date :placeholder="$t('pleaseSelectADate')"
                          v-model.trim="xhDeferForm.DELAY_END_DATE" style="width: 100%"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col>
              <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}"
                                 :label="`${$t('postpone')}${$t('reason')}`" prop="DELAY_DESC">
                <a-textarea
                    v-model.trim="xhDeferForm.DELAY_DESC"
                    :placeholder="$t('IssueNumber')"
                    :auto-size="{ minRows: 3, maxRows: 10 }"
                />
              </a-form-model-item>
            </a-col>
          </a-row>
        </dol-form-model>
      </a-modal>

      <!--批量还箱-->
      <a-modal v-model.trim="xhConfirmShow" centered width="50%" :okText="$t('confirm')" :cancelText="$t('cancel')"
               :title="$t('batchReturnBox')" @ok="allConfirmXhOrder" @cancel="xhForm = {}">
        <dol-form-model :model="xhForm" :rules="xhValidateRules" ref="xhAllForm">
          <a-row>
            <a-col :span="11">
              <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" :label="$t('returnBoxTime')"
                                 prop="RET_DATE">
                <dol-date :placeholder="$t('pleaseSelectADate')" v-model.trim="xhForm.RET_DATE" :disabled-date="v => $moment().endOf('day').isBefore(v)" style="width: 100%"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="11" offset="2">
              <a-form-model-item :labelCol="{span: 24}" :wrapperCol="{span: 24}" :label="$t('returnBoxDocuments')"
                                 prop="GUID_CODES">
                <dol-upload @finished="xhFinished" :paramsData="xhParamsData" :text="$t('uploadReturnBoxDocuments')"
                            serverType="2009" v-model.trim="xhForm.GUID_CODES"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-model-item :label="$t('pleaseSelectTheCaseNumber')" :labelCol="{span: 24}"
                                 :wrapperCol="{span: 24}"
                                 prop="BOX_ARR">
                <div style="border: 1px solid #eeeeee;border-radius: 4px;padding: 10px 20px;line-height: 1;">
                  <div style="margin-bottom: 12px">
                    {{ $t('total') }}{{ xhBoxOptions.length }}{{ $t('containersCanBeReturnedPleaseSelect') }}
                  </div>
                  <a-checkbox-group v-model.trim="xhForm.BOX_ARR" :options="xhBoxOptions"></a-checkbox-group>
                </div>
              </a-form-model-item>
            </a-col>
          </a-row>
        </dol-form-model>
      </a-modal>

      <!--集装箱详情-->
      <a-modal v-model.trim="boxVisible" centered width="60%" :title="$t('containerDetails')" :footer="false">
        <a-descriptions :column="2">
          <a-descriptions-item :label="$t('通用_箱号')">
            {{ boxForm.BOX_CODE }}
          </a-descriptions-item>
          <a-descriptions-item :label="$t('通用_箱型')">
            {{ $dt(boxForm, 'BOX_SIZE_NAME') }}
          </a-descriptions-item>
          <a-descriptions-item :label="$t('TakeBoxTime')">
            {{ $moment(boxForm.SEND_DATE).format('YYYY-MM-DD') }}
          </a-descriptions-item>
          <a-descriptions-item :label="$t('returnBoxTime')">
            {{ $moment(boxForm.BOX_OUT_DATE).format('YYYY-MM-DD') }}
          </a-descriptions-item>
          <a-descriptions-item :label="$t('status')">
            {{ $dt(boxForm, 'STORE_STATUS_NAME') }}
          </a-descriptions-item>
        </a-descriptions>
      </a-modal>

      <!--集装箱图片-->
      <a-modal v-model.trim="imageShow" centered width="30%" :title="$t('pictureOfContainer')" :footer="false">
        <dol-image-list-preview :imageList="FILE_LIST"></dol-image-list-preview>
      </a-modal>

      <!--  添加箱异常  -->
      <a-modal v-model.trim="boxShow" width="60%" :title="$t('boxError')" :okText="$t('confirm')"
               :cancelText="$t('cancel')" destroyOnClose @ok="addExceptBox">
        <a-textarea
            v-model.trim="boxForm.BOX_EX_DESC"
            :placeholder="$t('pleaseFillBoxErrorText')"
            :auto-size="{ minRows: 5 }"
        />
      </a-modal>

      <!--  箱异常详情  -->
      <a-modal v-model.trim="boxErrorShow" centered width="50%" :footer="false"
               :title="$t('boxExceptionDetails')">
        <div>
          <a-row :gutter="[16,16]">
            <a-col :span="24">
              {{ $t('specialCause') }}：{{ boxErrData.BOX_EX_DESC1 }}
            </a-col>
            <a-col :span="24">
              <div style="display: flex">
                {{ $t('resultCode') }}：
                <div v-if="boxErrData.BOX_EX_RET_DATE">
                  <div>{{ $t('processMode') }}:{{ $t('instantReturnBox') }}</div>
                  <div>{{ $t('通用_堆场') }}: {{ $dt(boxErrData, 'SPACE_NAME') }}(
                    <dol-dict :option="boxErrData.BOX_EX_RET_SPACE_TYPE" code="2004"/>
                    )
                  </div>
                  <div>{{ $t('returnBoxTime') }}: {{ $moment(boxErrData.BOX_EX_RET_DATE).format('YYYY-MM-DD') }}</div>
                  <div>{{ $t('通用_备注') }}: {{ boxErrData.BOX_EX_MEMO }}</div>
                </div>
                <div v-else>{{ boxErrData.BOX_EX_RESULT }}</div>
              </div>
            </a-col>
            <a-col :span="24">
              <a-space v-if="boxErrData.imageList">
                <template v-for="item in boxErrData.imageList">
                  <dol-image-list-preview :imageList="[{FILE_NAME: item}]"></dol-image-list-preview>
                </template>
              </a-space>
            </a-col>
          </a-row>
        </div>
      </a-modal>

      <!--  提箱单详情  -->
      <a-modal v-model.trim="xeDetailShow" centered width="60%" :title="$t('packingListDetails')" :footer="false">
        <a-descriptions :column="3" layout="vertical">
          <a-descriptions-item>
            <template slot="label">
              <span>{{ $t('putBoxOrderNumber') }}</span>
            </template>
            <div>{{ xeForm?.SEND_CODE }}</div>
          </a-descriptions-item>
          <a-descriptions-item>
            <template slot="label">
              <span>{{ $t('通用_还箱地') }}</span>
            </template>
            <span>{{ $dt(xeForm, 'CITY_NAME') }}</span>
          </a-descriptions-item>
          <a-descriptions-item>
            <template slot="label">
              <span>{{ $t('putBoxIndate') }}</span>
            </template>
            <span>{{ $moment(xeForm.BEGIN_DATE).format('YYYY-MM-DD') }}~{{
                $moment(xeForm.END_DATE).format('MM-DD')
              }}</span>
          </a-descriptions-item>
          <a-descriptions-item>
            <template slot="label">
              <span>{{ $t('putBoxCyName') }}</span>
            </template>
            <span>{{ $dt(xeForm, 'SPACE_NAME') }}</span>
          </a-descriptions-item>
          <a-descriptions-item>
            <template slot="label">
              <span>{{ $t('通用_箱型') }}</span>
            </template>
            <span>{{ $dt(xeForm, 'BOX_SIZE_NAME') }}</span>
          </a-descriptions-item>
          <a-descriptions-item>
            <template slot="label">
              <span>{{ $t('通用_箱量') }}</span>
            </template>
            <span>{{ xeForm.REAL_QTY }}</span>
          </a-descriptions-item>
          <a-descriptions-item>
            <template slot="label">
              <span>{{ $t('putBoxCyAddress') }}</span>
            </template>
            <span>{{ xeForm.SEND_SPACE_ADDRESS }}</span>
          </a-descriptions-item>
          <a-descriptions-item>
            <template slot="label">
              <span>{{ $t('containerYardPhone') }}</span>
            </template>
            <span>{{ xeForm.SEND_SPACE_PERSON }}</span>
          </a-descriptions-item>
          <a-descriptions-item>
            <template slot="label">
              <span>{{ $t('通用_备注') }}</span>
            </template>
            <span>{{ xeForm.MEMO }}</span>
          </a-descriptions-item>
        </a-descriptions>
      </a-modal>

      <!--  箱跟踪  -->
      <a-modal v-model.trim="boxHistoryShow" centered width="50%" :footer="false"
               :title="$t('boxTracking')">
        <template v-if="boxHistoryList?.length > 0">
          <div class="box-status-title">
            <div class="box-status-title-left">{{ $t('boxRoute') }}</div>
            <div class="box-status-title-right">{{ $t('updateTime') }}：{{boxHistory.LAST_UPDATE_DATE}}</div>
          </div>
          <div class="box-status-content">
            <div class="box-status-content-title">{{ $t('totalVoyage') }}：32{{ $t('day') }}</div>
            <div class="trans-template-line">
              <template v-for="(detail,index1) in boxHistoryList">
                <div class="trans-template-line__site">
                  <div class="trans-template-line__site__title">
                    <div class="trans-template-line__site__title__if" v-if="index1 === 0"><img
                        class="trans-template-line__site__title__icon"
                        src="../../../public/static/icon/takeCityLogo.svg"/>{{ $t('takeBoxPlace') }}
                    </div>
                    <div class="trans-template-line__site__title__if" v-else><img
                        class="trans-template-line__site__title__icon"
                        src="../../../public/static/icon/transferStation.svg"/>{{ $t('transferStation') }}
                    </div>
                  </div>
                  {{ $dt(detail, 'CITY_NAME') }}
                </div>
                <div class="trans-template-line__dot-line"></div>
                <div class="trans-template-line__icon">
                  <img v-if="detail.SHIP_TYPE === 20061002" style="width: 32px"
                       src="../../../public/static/icon/railTrans.svg"/>
                  <img v-else style="width: 32px" src="../../../public/static/icon/seaTrans.svg"/>
                </div>
                <div class="trans-template-line__dot-line"></div>
                <div class="trans-template-line__site" v-if="index1 !== 0 || boxHistoryList.length === 1">
                  <div class="trans-template-line__site__title"><img class="trans-template-line__site__title__icon"
                                                                     src="../../../public/static/icon/returnCityLogo.svg"/>{{ $t('通用_还箱地') }}
                  </div>
                  {{ $dt(detail, 'D_CITY_NAME') }}
                </div>
              </template>
            </div>
            <div class="box-status-content-date">
              <div>
                <div>{{ $t('estimatedStartDate') }}：{{boxHistoryList[0]?.YJ_START_DATE ?  $moment(boxHistoryList[0]?.YJ_START_DATE).format('YYYY-MM-DD') : ''}}</div>
                <div>{{ $t('actualStartDate') }}：{{ boxHistoryList[0]?.SJ_START_DATE ? $moment(boxHistoryList[0]?.SJ_START_DATE).format('YYYY-MM-DD') : '' }}</div>
              </div>
              <div>
                <div>{{ $t('expectedDateOfArrival') }}：{{ boxHistoryList[boxHistoryList?.length-1]?.YJ_END_DATE ? $moment(boxHistoryList[boxHistoryList?.length-1]?.YJ_END_DATE).format('YYYY-MM-DD') : ''}}</div>
                <div>{{ $t('actualArrivalDate') }}：{{ boxHistoryList[boxHistoryList?.length-1]?.SJ_END_DATE ? $moment(boxHistoryList[boxHistoryList?.length-1]?.SJ_END_DATE).format('YYYY-MM-DD') : '' }}</div>
              </div>
            </div>
          </div>
          <div class="box-status-title">{{ $t('containerMovement') }}</div>
          <div class="box-status__code">
            <div class="box-status__code__left">{{ $t('通用_箱号') }}：{{ boxHistoryList[0]?.BOX_CODE }}</div>
            <div class="box-status__code__right">{{ $t('status') }}：{{ $dt(boxHistory, 'OPER_STATUS_NAME') }}</div>
          </div>
          <div style="margin-top: 24px">
            <a-timeline>
              <a-timeline-item>{{ boxHistoryList[0]?.SJ_START_DATE ? $moment(boxHistoryList[0]?.SJ_START_DATE).format('YYYY-MM-DD') : boxHistoryList[0]?.YJ_START_DATE ? `(${$t('expected')})${ $moment(boxHistoryList[0]?.YJ_START_DATE).format('YYYY-MM-DD') }` : '' }}{{ boxHistoryList[0] ? $dt(boxHistoryList[0], 'CITY_NAME') : '' }} {{ boxHistoryList[0] ? $dt(boxHistoryList[0], 'SW_NAME') : '' }}</a-timeline-item>
              <a-timeline-item v-for="(detail,index1) in boxHistoryList" :key="index1" :color="detail.SJ_END_DATE ? 'blue' : 'gray'">{{detail.SJ_END_DATE ? $moment(detail.SJ_END_DATE).format('YYYY-MM-DD') : detail.YJ_END_DATE ? `(${$t('expected')})${ $moment(detail.YJ_END_DATE).format('YYYY-MM-DD')}` : '' }} {{ $dt(detail, 'D_CITY_NAME') }} {{ $dt(detail, 'D_SW_NAME')}} {{`【${ $dt(detail,'SHIP_NAME') || '-'} / ${detail.SHIP_CODE || '-'}】`}}</a-timeline-item>
            </a-timeline>
          </div>
        </template>
        <a-empty :description="false" v-else/>
      </a-modal>
    </dol-row>

    <!--减少箱量申请-->
    <reduce-number-modal :sheet-data="sheetData" @reload="getOrderDetail" ref="reduceNumberModal" />
  </div>
</template>

<script>
import xfScript from "./orderDetailScript/xfScript";
import xeScript from "./orderDetailScript/xeScript";
import sheetScript from "./orderDetailScript/sheetScript";
import xgScript from "./orderDetailScript/xgScript";
import xhScript from "./orderDetailScript/xhScript";
import mixin from "../../components/common/commonErpPageScript";
import transportTree from "@/components/common/transportTree";
import cargoTransport from "@/components/common/cargoTransport";
import diffCityReturnList from '@/views/order/components/diff-city-return-list.vue';
import reduceNumberModal from '@/views/order/components/reduce-number-modal.vue';
import cargoApplyReturnList from '@/views/order/components/cargo-apply-return-list.vue';

export default {
  mixins: [xfScript, xeScript, sheetScript, xgScript, xhScript, mixin],
  components: { cargoApplyReturnList, reduceNumberModal, diffCityReturnList, transportTree,cargoTransport},
  name: "orderDetail",
  data() {
    return {
      sheetData: {},
      xbOrderMaster: {},

      transTypeList: [],
      hintVisible: false,
      boxVisible: false,
      orderForm: {},
      boxShow: false,
      boxForm: {},
      orderRuleList: [],
      priceList: [],
      queryForm: {},
      orderData: {},
      BOX_LIST: [],
      CHARGE_LIST: [],
      CHARGE_LIST_MAP: {},
      loading: true,
      imageShow: false,
      FILE_LIST: [],
      xeFileMap: {},
      xhFileMap: {},
      BOX_EX_LIST: [],
      boxErrData: {},
      boxErrorShow: false,
      current: 1,
      total: 0,
      boxHistoryShow: false,
      boxHistoryList: [],
      boxHistory: {},
      useHintVisible: false,
      activeKey: '',
      boxImg: require('../../../public/static/icon/box.svg'),
      xhFlag: false
    }
  },
  computed: {
    boxColumns() {
      let columns = [];
      columns.push({dataIndex: 'BOX_CODE', title: this.$t('通用_箱号')});
      columns.push({dataIndex: this.$kt('BOX_SIZE_NAME'), title: this.$t('通用_箱型')});
      /*columns.push({dataIndex: 'STORE_STATUS_NAME', title: '状态'});*/
      columns.push({dataIndex: 'SEND_DATE', title: this.$t('TakeBoxTime'), scopedSlots: {customRender: 'SEND_DATE'}});
      columns.push({dataIndex: this.$kt('OPER_STATUS_NAME'), title: this.$t('status')});
      columns.push({dataIndex: 'RET_DATE', title: this.$t('returnBoxTime'), scopedSlots: {customRender: 'RET_DATE'}});
      columns.push({dataIndex: '_id', width: '120px', scopedSlots: {customRender: 'operation'}});

      return columns;
    },
    columns() {
      let columns = [];
      columns.push({dataIndex: 'BOX_CODE', title: this.$t('通用_箱号')});
      // columns.push({dataIndex: 'BOX_NAME', title: '箱名'});
      // columns.push({dataIndex: 'BOX_STATUS_NAME', title: '箱况'});
      columns.push({dataIndex: this.$kt('BOX_SIZE_NAME'), title: this.$('通用_箱型')});
      // columns.push({ dataIndex: 'STORE_STATUS', title: '存放状态' });
      columns.push({dataIndex: this.$kt('DIC_NAME'), title: this.$t('status')});
      columns.push({dataIndex: '_id', width: '40px', scopedSlots: {customRender: 'operation'}});

      return columns;
    },
    chargePriceTotal() {
      let priceObj = {};
      let priceList = []
      this.CHARGE_LIST.forEach(item => {
        if (priceObj[item.CURRENCY_ID]) {
          priceObj[item.CURRENCY_ID].AMT += item.ACCT_TYPE === 0 ? -item.AMT : item.AMT;
        } else {
          priceObj[item.CURRENCY_ID] = {...item}
          priceObj[item.CURRENCY_ID].AMT = item.ACCT_TYPE === 0 ? -item.AMT : item.AMT;
        }
      })
      for (let obj in priceObj) {
        priceList.push(priceObj[obj])
      }
      return priceList;
    },
    unBoxColumns() {
      let columns = [];
      columns.push({dataIndex: 'BOX_CODE', title: this.$t('通用_箱号')});
      columns.push({dataIndex: 'BOX_EX_DESC1', title: this.$t('specialCause')});
      columns.push({
        dataIndex: 'BOX_EX_RESULT1',
        title: this.$t('resultCode'),
        scopedSlots: {customRender: 'BOX_EX_RESULT'}
      });
      columns.push({dataIndex: this.$kt('OPER_STATUS_NAME'), title: this.$t('status')});
      columns.push({dataIndex: '_id', width: '80px', scopedSlots: {customRender: 'operation'}});

      return columns;
    },
  },
  methods: {
    downXhCargoFile(data) {
      let condition = {
        "SYS_TYPE": "20011003",
        "TARGET_CATE": "20021011",
        "TARGET_TYPE": "20071003",
        "TARGET_ID": data.FLOW_ID
      }
      this.$h5Api({
        type: '2021',
        data: [condition],
      }).then(({data}) => {
        this.$Dolphin.download(this.$t('returnBoxDocuments'), this.$Dolphin.path.filePath + data?.FILE_LIST?.[0]?.FILE_NAME)
      })
    },
    openBoxDetailModal(data) {
      this.boxErrData = Object.assign({}, data);
      if (this.boxErrData.BOX_EX_FILE1) {
        this.boxErrData.imageList = this.boxErrData.BOX_EX_FILE1.split(',')
      }
      this.boxErrorShow = true;
    },
    openBoxErrorModal(data) {
      this.boxForm = Object.assign({}, data);
      this.boxShow = true;
    },
    addExceptBox() {
      let condition = {
        "FLOW_ID": this.boxForm.FLOW_ID,
        "BOX_EX_STATUS": 1,
        "BOX_EX_DESC": this.boxForm.BOX_EX_DESC
      }
      if (this.loading) {
        this.loading = false;
        this.$h5Api({
          type: '4050',
          data: [condition],
        }).then(({data}) => {
          this.boxShow = false;
          this.getOrderDetail(this.$route.query.MASTER_ID)
          this.$message.info(this.$t('successfullyAdded'));
        }).finally(e => {
          this.loading = true;
        })
      }
    },
    openImageModal(data) {
      let fileList = [];
      data.split(',').forEach(item => {
        fileList.push(item);
      })
      this.FILE_LIST = fileList;
      this.imageShow = true;
    },
    downPayCard() {
      let condition = {
        "SYS_TYPE": "20011003",
        "TARGET_CATE": "20021009",
        "TARGET_TYPE": "20071004",
        "TARGET_ID": this.orderForm.MASTER_ID
      }
      this.$h5Api({
        type: '2021',
        data: [condition],
      }).then(({data}) => {
        this.$Dolphin.download(this.$t('payOrder'), this.$Dolphin.path.filePath + data?.FILE_LIST?.[0]?.FILE_NAME)
      })
    },
    confirmPrice() {
      let condition = [];
      this.CHARGE_LIST.forEach(item => {
        condition.push({FLOW_ID: item.FLOW_ID})
      })
      this.$confirm({
        content: this.$t('whetherToRecognizeTheCost'),
        okText: this.$t('confirm'),
        cancelText: this.$t('cancel'),
        onOk: () => {
          if (this.loading) {
            this.loading = false;
            this.$h5Api({
              type: '4046',
              data: condition,
            }).then(({data}) => {
              this.getOrderDetail(this.$route.query.MASTER_ID);
              this.$message.info(this.$t('confirmationSuccessful'))
            }).finally(() => {
              this.loading = true;
            })
          }
        }
      })
    },
    confirmDemurrage(record) {
      this.$confirm({
        content: this.$t('whetherToConfirmTheDetentionFee'),
        onOk: () => {
          if (this.loading) {
            this.loading = false;
            this.$h5Api({
              type: '4042',
              data: [{
                "OPER_TYPE": 0,
                "FLOW_ID": record.FLOW_ID
              }],
            }).then(({data}) => {
              this.$message.info(this.$t('confirmationSuccessful'))
            }).finally(() => {
              this.loading = true;
            })
          }
        },
        onCancel() {
        },
      });
    },
    getOrderDetail(MASTER_ID) {
      if(!MASTER_ID){
        MASTER_ID = this.$route.query.MASTER_ID;
      }
      this.$h5Api({
        type: '4025',
        data: [{
          "QUERY_TYPE": 0,
          "MASTER_ID": MASTER_ID,
        }],
      }).then(({data}) => {
        data.XG_APPLY_LIST = data.XG_APPLY_LIST.sort((a, b) => a.CREATE_DATE > b.CREATE_DATE ? 1 : -1);
        this.sheetData = data;
        this.xbOrderMaster = data?.OT_XB_MASTER[0] || {};
        this.orderForm = Object.assign({}, data?.OT_XC_MASTER?.[0], data?.OT_XC_DETAIL?.[0]);
        let priceList = [];
        data.OT_XC_DETAIL.forEach(item => {
          priceList.push(Object.assign({}, data?.OT_XC_MASTER?.[0], item));
        })
        let xeList = [];
        let xeMasterMap = {};

        data.OT_BOX_XE_MASTER.filter(item => item.OPER_STATUS !== 4)?.forEach(item => {
          if (item.CHECK_STATUS === 1) {
            item.takeFlag = true
            xeMasterMap[item.MASTER_ID] = item;
            xeMasterMap[item.MASTER_ID].boxArr = []
          }
        })
        //data.OT_BOX_XE_MASTER
        data.OT_BOX_XE_DETAIL.forEach(item => {
          if (xeMasterMap[item.MASTER_ID]) {
            xeList.push(Object.assign({}, xeMasterMap[item.MASTER_ID], item));
          }
        })
        data.OT_XF_DETAIL.forEach(item => {
          xeList.find(xeForm => xeForm.FLOW_ID === item.PARENT_FLOW_ID)?.boxArr.push(item)
        })

        let sheetList = [];
        let transMap = {};
        data.OT_SHEET_SHIP.forEach(item => {
          if (transMap[item.SHIP_CODE]) {
            transMap[item.SHIP_CODE].BOX_CODE_ARR.push({
                  BOX_CODE: item.BOX_CODE,
                  FLOW_ID: item.FLOW_ID,
                  BOX_ID: item.BOX_ID
                }
            );
          } else {
            item.BOX_CODE_ARR = [{BOX_CODE: item.BOX_CODE, FLOW_ID: item.FLOW_ID, BOX_ID: item.BOX_ID}
            ];
            transMap[item.SHIP_CODE] = item;
          }
        })
        for (let trans in transMap) {
          sheetList.push(transMap[trans])
        }
        this.sheetList = sheetList;
        let xgList = [];
        let xgMasterMap = {};
        data.OT_XG_DETAIL.forEach(item => {
          if (xgMasterMap[item.MASTER_ID]) {
            xgMasterMap[item.MASTER_ID].BOX_CODE_ARR.push({
              BOX_CODE: item.BOX_CODE,
              BOX_ID: item.BOX_ID,
              RET_STATUS: item.RET_STATUS,
              PARENT_FLOW_ID: item.FLOW_ID
            });
          } else {
            item.BOX_CODE_ARR = [{
              BOX_CODE: item.BOX_CODE,
              BOX_ID: item.BOX_ID,
              RET_STATUS: item.RET_STATUS,
              PARENT_FLOW_ID: item.FLOW_ID
            }];
            xgMasterMap[item.MASTER_ID] = item;
          }
        })
        data.OT_XG_MASTER.forEach(item => {
          xgMasterMap[item.MASTER_ID].CITY_ID = item.CITY_ID;
          xgMasterMap[item.MASTER_ID].CITY_NAME = item.CITY_NAME;
          xgMasterMap[item.MASTER_ID].CITY_NAME_ENG = item.CITY_NAME_ENG;
          xgMasterMap[item.MASTER_ID].CITY_NAME_RUS = item.CITY_NAME_RUS;
          xgMasterMap[item.MASTER_ID].D_CITY_ID = item.D_CITY_ID;
          xgMasterMap[item.MASTER_ID].D_CITY_NAME = item.D_CITY_NAME;
          xgMasterMap[item.MASTER_ID].D_CITY_NAME_ENG = item.D_CITY_NAME_ENG;
          xgMasterMap[item.MASTER_ID].D_CITY_NAME_RUS = item.D_CITY_NAME_RUS;
        })
        for (let xgMaster in xgMasterMap) {
          xgList.push(xgMasterMap[xgMaster])
        }
        this.xgList = xgList;
        this.xgApply();
        let xhMasterMap = {};
        data.OT_XH_MASTER.forEach(item => {
          item.boxArr = [];
          item.isConfirm = true
          item.IS_TAKE = true
          item.xhFlag = true
          xhMasterMap[item.MASTER_ID] = {...item};
        })
        data.OT_XH_DETAIL.forEach(item => {
          if (item.RET_STATUS !== 2 && xhMasterMap[item.MASTER_ID]) {
            xhMasterMap[item.MASTER_ID].isConfirm = false
          }
          if (xhMasterMap[item.MASTER_ID]) {
            if (!(item.RET_STATUS === 3 || item.RET_STATUS === 7 || item.RET_STATUS === 10)) {
              xhMasterMap[item.MASTER_ID].IS_TAKE = false
            }
            xhMasterMap[item.MASTER_ID].boxArr.push({...item})
          }
        })
        this.xhList = Object.values(xhMasterMap).filter(item => {
          return item.RET_STATUS !== 9;
        });
        if(this.xhList.length > 0) {
          this.xhList.map(item => {
            item.BOX_NUM = item.boxArr?.length;
            item.RET_BOX_NUM = item.boxArr?.filter(item => (/4|10/.test(item.RET_STATUS)))?.length
            return item
          })
        }
        this.xeList = xeList;
        this.priceList = priceList;
        let xeFileMap = {};
        data.OT_BOX_XE_FILE.forEach(item => {
          xeFileMap[item.TARGET_ID + String(item.SYS_TYPE)] = item;
        })
        this.xeFileMap = xeFileMap;
        let xhFileMap = {};
        data.OT_XH_FILE.forEach(item => {
          xhFileMap[item.TARGET_ID + String(item.SYS_TYPE)] = item;
        })
        this.xhFileMap = xhFileMap;
        let xfFileMap = {};
        data.OT_XF_FILE.forEach(item => {
          if (!xfFileMap[item.TARGET_ID]) {
            xfFileMap[item.TARGET_ID] = [];
          }
          xfFileMap[item.TARGET_ID].push({
            FILE_NAME: item.FILE_NAME,
            GUID_CODE: item.GUID_CODE
          })
        })
        this.xfFileMap = xfFileMap;
        data.BOX_LIST.forEach(item => {
          if (this.getXhBoxMap[item.BOX_CODE] && item.RET_STATUS == 3 && this.getXhBoxMap[item.BOX_CODE].RET_SPACE_ID) {
            item['MASTER_ID'] = this.getXhBoxMap[item.BOX_CODE]['MASTER_ID'];
            item['AFFIRM_FLOW_ID'] = this.getXhBoxMap[item.BOX_CODE]['FLOW_ID'];
          } else if (this.getXhBoxMap[item.BOX_CODE] && this.getXhBoxMap[item.BOX_CODE].RET_SPACE_ID) {
            item['DOWNLOAD_FLOW_ID'] = this.getXhBoxMap[item.BOX_CODE]['FLOW_ID'];
            item['EDIT_DATA_MASTER_ID'] = this.getXhBoxMap[item.BOX_CODE]['MASTER_ID'];
            item['XH_FILE_GUID_CODE'] = this.getXhBoxMap[item.BOX_CODE]['XH_FILE_GUID_CODE'];
          }
          if(/4|10/.test(item.RET_STATUS)) {
            item.extraDays = this.orderForm.USE_DAYS - this.$moment(item.RET_DATE).diff(item.SEND_DATE, 'day') - 1;
          } else {
            item.extraDays = this.orderForm.USE_DAYS - this.$moment(new Date()).diff(item.SEND_DATE, 'day') - 1;
          }
        })
        this.BOX_LIST = data.BOX_LIST.filter(val => !val.BOX_EX_STATUS);
        this.BOX_EX_LIST = data.BOX_LIST.filter(val => val.BOX_EX_STATUS);
        this.CHARGE_LIST = data.CHARGE_LIST;
        let CHARGE_LIST_MAP = {};
        data.CHARGE_LIST.forEach(item => {
          if (!CHARGE_LIST_MAP[item.CHARGE_NAME]) {
            CHARGE_LIST_MAP[item.CHARGE_NAME] = [];
          }
          CHARGE_LIST_MAP[item.CHARGE_NAME].push(item);
        })
        this.CHARGE_LIST_MAP = CHARGE_LIST_MAP;
        let tree = this.arrayToTree(data.OT_TRACK_SHIP, null)
        this.transportList = [...tree]
      })
    },
    disabledRetDate(current) {
      return current && current <= this.$moment(this.xhForm.SEND_DATE);
    },
    disabledDate(current) {
      return current && current <= this.$moment(this.deferForm.END_DATE).startOf('day');
    },
    /*disabledXfDate(current){
      return current && current <= this.$moment(this.xfForm.BEGIN_DATE).startOf('day');
    },*/
    beginDisabledDate(current) {
      if (this.xgForm.END_DATE) {
        return current <= this.$moment(this.orderData.END_DATE).startOf('day').add(3, 'day') || current >= this.$moment(this.xgForm.END_DATE).startOf('day')
      }
      return current && current <= this.$moment(this.orderData.END_DATE).startOf('day').add(3, 'day');
    },
    endDisabledDate(current) {
      if (this.xgForm.BEGIN_DATE) {
        return current <= this.$moment(this.xgForm.BEGIN_DATE).add(1, 'day')
      } else {
        return current && current <= this.$moment(this.orderData.END_DATE).add(4, 'day');
      }
    },
    getOrderRule(MASTER_ID) {
      this.$h5Api({
        type: '4014',
        data: [{
          "QUERY_TYPE": 0,
          "MASTER_ID": MASTER_ID,
          "IS_NEW": 1
        }],
      }).then(({data}) => {
        this.orderRuleList = data.XCD_DELAY_RULE;
      })
    },
    boxModel(record) {
      this.boxVisible = true;
      this.boxForm = record
    },
    arrayToTree(arr, parent) {
      let tree = [];
      arr.forEach(item => {
        if (item.PARENT_SHIP_ID === parent) {
          let node = {
            ...item,
            children: this.arrayToTree(arr, item.SHIP_ID)
          };
          tree.push(node);
        }
      })
      return tree;
    },
    openBoxHistoryModal(BOX_ID) {
      let condition = {
        XC_MASTER_ID: this.orderForm.MASTER_ID,
        BOX_ID
      }
      this.$h5Api({
        type: '4074',
        data: [condition],
      }).then(({data}) => {
        this.boxHistoryList = data.LIST.sort((a,b) => a.PARENT_SHIP_ID - b.PARENT_SHIP_ID);
        this.boxHistory = data.OTHER_LIST[0]
        this.boxHistoryShow = true;
      })
    },
    removeFile() {
      this.getOrderDetail(this.$route.query.MASTER_ID)
    },

    getDelayStyle(record){
      if(!record.DELAY_END_DATE){
        return {color: '#999999'};
      }

      if(this.$moment(record.END_DATE).format('YYYY-MM-DD') >= this.$moment(record.DELAY_END_DATE).format('YYYY-MM-DD')){
        return {color: '#999999'};
      }

      return {color: 'red'};
    },
  },
  created() {
    if (this.$route.query.MASTER_ID) {
      this.getOrderRule(this.$route.query.MASTER_ID);
      this.getOrderDetail(this.$route.query.MASTER_ID);
    }
    this.$dict(2006, null, {labelField: 'text', valueField: 'DIC_CODE'}).then(data => {
      this.transTypeList = data;
    });
  }
}
</script>

<style lang="scss">
@import "src/assets/scss/orderDetail.scss";
</style>